import type { PropsWithChildren } from "react";

export function PromoContainer({
  children,
}: PropsWithChildren<{
  navigateToHotels?: () => void;
}>) {
  return (
    <div className="relative flex w-full flex-col gap-6 bg-surface px-4 pt-6 pb-4 md:rounded-lg">
      {children}
    </div>
  );
}
